import { render, staticRenderFns } from "./EmailDomainTable.vue?vue&type=template&id=029b7310&"
import script from "./EmailDomainTable.vue?vue&type=script&lang=js&"
export * from "./EmailDomainTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports